export default "__VITE_ASSET__4b86f56e__"